module.exports = __webpack_public_path__ + "img/title-3.542ad568.png";